import {Injectable} from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import {forkJoin, Observable, of} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState} from '@store/app.states';
import {ToggleInLoggingScreen} from '@store/actions/auth.actions';
import {AuthService} from '@app/services/auth/auth.service';
import {catchError, map, switchMap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthResolver  {

  constructor(
    private store: Store<AppState>,
    private authService: AuthService
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

    const token = route.queryParamMap.get('jwtToken');

    let waitForLoginWithToken = of(true);

    if (token) {

      waitForLoginWithToken = this.authService.secretKeyLogin(token).pipe(
        map(() => {
          this.store.dispatch(new ToggleInLoggingScreen({value: false}));
          return true;
        }),
        catchError(() => {
          this.store.dispatch(new ToggleInLoggingScreen({value: false}));
          return of(false);
        })
      );
    } else {

      this.store.dispatch(new ToggleInLoggingScreen({value: true}));

    }

    return forkJoin([waitForLoginWithToken])
      .pipe(
        switchMap(results => {
          this.store.dispatch(new ToggleInLoggingScreen({value: true}));
          if (results.includes(false)) {
            return of(false);
          }
          return of(true);

        })
      );

  }

}
